import React from 'react';
import { useForm, Link } from '@inertiajs/react';
import AuthLayout from '../../layouts/AuthLayout';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';

export default function PasswordResetNew({ csrf_token }) {
  const { data, setData, post, processing, errors } = useForm({
    email: '',
    authenticity_token: csrf_token
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    post('/identity/password_reset');
  };

  return (
    <AuthLayout 
      title="Reset your password"
      description="Enter your email to receive password reset instructions"
    >
      <form className="space-y-6" onSubmit={handleSubmit}>
        <div className="space-y-2">
          <Label htmlFor="email">Email address</Label>
          <Input
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            required
            placeholder="name@example.com"
            value={data.email}
            onChange={e => setData('email', e.target.value)}
          />
          {errors.email && <p className="text-sm text-destructive mt-1">{errors.email}</p>}
        </div>

        <Button
          type="submit"
          className="w-full"
          disabled={processing}
        >
          {processing ? 'Sending reset instructions...' : 'Send reset instructions'}
        </Button>

        <div className="text-center mt-6">
          <p className="text-sm text-muted-foreground">
            <Link href="/sign_in" className="font-medium text-primary hover:underline">
              Back to sign in
            </Link>
          </p>
        </div>
      </form>
    </AuthLayout>
  );
}
